import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-12"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-0 -left-4 w-72 h-72 sm:w-96 sm:h-96 bg-brand-pink rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
          <div className="absolute top-0 -right-4 w-72 h-72 sm:w-96 sm:h-96 bg-brand-aqua rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-20 w-72 h-72 sm:w-96 sm:h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
        </div>
        {/* Fade to body */}
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1600px] mx-auto w-full">
        <div className="flex flex-col items-center text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-2 sm:space-y-3"
          >
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-[80px] font-extralight leading-[1.1] tracking-tight">
              <span className="text-white">AI GENERATIVE</span>
            </h1>
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-[80px] font-extralight leading-[1.1] tracking-tight">
              <span className="bg-gradient-to-r from-brand-pink via-brand-aqua to-brand-pink bg-clip-text text-transparent">
                IMAGE &amp; VIDEO
              </span>
            </h1>
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-[80px] font-extralight leading-[1.1] tracking-tight">
              <span className="text-white">CREATION STUDIO</span>
            </h1>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-base sm:text-xl md:text-2xl text-white/90 mt-4 sm:mt-8 lg:mt-12 max-w-xl font-light leading-relaxed line-clamp-2"
          >
            Where imagination meets artificial intelligence
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-6 sm:mt-12 lg:mt-16 w-full sm:w-auto"
          >
            <Link to="/services" className="block sm:inline-block">
              <motion.button
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:w-auto px-10 py-4 bg-white text-black rounded-full font-semibold text-base flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl"
              >
                View Our Services
                <i className="ri-arrow-right-line text-xl"></i>
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
